module.exports = __webpack_public_path__ + "assets/img/3.4c9b356c.png";